import type { ModelProductItemsSearchFilter } from '@app/api/Products';
import { PRODUCTS_REGISTRY_STORAGE_KEY } from '@app/pages/Warehouses/Products/data';
import { safeParseJson } from '@app/shared/utils';

export const writeSession = (value: ModelProductItemsSearchFilter) => {
  sessionStorage.setItem(PRODUCTS_REGISTRY_STORAGE_KEY, JSON.stringify(value));
};

export const readSession = () =>
  safeParseJson<ModelProductItemsSearchFilter>(
    sessionStorage.getItem(PRODUCTS_REGISTRY_STORAGE_KEY)
  );

export const clearSession = () => {
  sessionStorage.removeItem(PRODUCTS_REGISTRY_STORAGE_KEY);
};
